module.exports = __webpack_public_path__ + "static/media/whatsapp_new3.e2b04038.svg";